import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink, faList, faTable } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import useInvoice from '@hooks/useInvoice'

import handleCallbackAction from '@functions/handleCallbackAction'

interface InvoiceToolsProps {
  callbacks: {
    setState: (state: {viewMode: string}) => void,
  },
  hasActiveSession: boolean,
  selectedAgencyId: number,
  viewMode: string,
}

const InvoicesTools = (props: InvoiceToolsProps) => {
  const {
    callbacks: { setState }, hasActiveSession, selectedAgencyId, viewMode,
  } = props

  const { callbacks: { syncExternalInvoices } } = useInvoice()

  const syncExternalInvoicesPayload = {
    callbacks: {
      action: syncExternalInvoices,
    },
    entityParams: {
      agencyId: selectedAgencyId,
      forceSync: true,
    },
    toastText: 'Invoices Synced',
  }

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={viewMode === 'table' ? faList : faTable} />}
        onClick={() => setState({ viewMode: viewMode === 'table' ? 'list' : 'table' })}
        size="medium"
      >
        {viewMode === 'table' ? 'View As List' : 'View As Table'}
      </Button>

      {hasActiveSession && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faLink} />}
          // @ts-expect-error TS2345
          onClick={() => handleCallbackAction(syncExternalInvoicesPayload)}
          marginTop="medium"
          size="medium"
        >
          Force Sync
        </Button>
      )}
    </Tools>
  )
}

export default InvoicesTools
